const { localStorage } = window;

/**
 * Update favorite count in snackbar.
 */
const updateFavoriteCount = () => {
	const favoriteDocuments = localStorage.getItem('favoriteDocuments');
	const postsList = favoriteDocuments ? JSON.parse(favoriteDocuments) : [];
	const postCount = postsList.length || 0;
	document.querySelector('.favorited-content-snackbar').setAttribute('data-count', postCount);
	document.querySelector('.favorited-content-snackbar p>span').innerHTML = postCount;
};

/**
 * Initiate favorite posts.
 */
const initFavoriteDocuments = () => {
	updateFavoriteCount();
	const favoriteToggle = document.querySelectorAll('.favorite-post-toggle');

	let favoriteDocuments = localStorage.getItem('favoriteDocuments');
	favoriteDocuments = favoriteDocuments ? JSON.parse(favoriteDocuments) : [];

	favoriteToggle.forEach((toggle) => {
		const { id } = toggle.dataset;
		const index = favoriteDocuments.indexOf(id);

		if (index > -1) {
			toggle.classList.add('active');
		}

		toggle.onclick = (e) => {
			e.preventDefault();
			const index = favoriteDocuments.indexOf(id);
			if (index === -1) {
				toggle.classList.add('active');
				favoriteDocuments.push(id);
			}

			if (index > -1) {
				toggle.classList.remove('active');
				favoriteDocuments.splice(index, 1);
			}

			localStorage.setItem('favoriteDocuments', JSON.stringify(favoriteDocuments));
			updateFavoriteCount();
		};
	});
};

export default initFavoriteDocuments;
